var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0088 3.36853C12.2977 3.14384 12.7023 3.14384 12.9912 3.36853L20.1912 8.96853C20.386 9.1201 20.5 9.35314 20.5 9.60001V18.4C20.5 19.0365 20.2471 19.647 19.7971 20.0971C19.347 20.5472 18.7365 20.8 18.1 20.8H6.9C6.26348 20.8 5.65303 20.5472 5.20294 20.0971C4.75286 19.647 4.5 19.0365 4.5 18.4V9.60001C4.5 9.35314 4.61398 9.1201 4.80885 8.96853L12.0088 3.36853ZM6.1 9.99128V18.4C6.1 18.6122 6.18429 18.8157 6.33431 18.9657C6.48434 19.1157 6.68783 19.2 6.9 19.2H18.1C18.3122 19.2 18.5157 19.1157 18.6657 18.9657C18.8157 18.8157 18.9 18.6122 18.9 18.4V9.99128L12.5 5.0135L6.1 9.99128Z",
    fill: "#545454"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.3 12C9.3 11.5582 9.65817 11.2 10.1 11.2H14.9C15.3418 11.2 15.7 11.5582 15.7 12V20C15.7 20.4418 15.3418 20.8 14.9 20.8C14.4582 20.8 14.1 20.4418 14.1 20V12.8H10.9V20C10.9 20.4418 10.5418 20.8 10.1 20.8C9.65817 20.8 9.3 20.4418 9.3 20V12Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHome);
export default __webpack_public_path__ + "static/media/ic-home.33cde62198474576f6d6fef99b2b3d27.svg";
export { ForwardRef as ReactComponent };